import React, { Component } from "react";
import Routes from "./Routes";
import { Link } from "react-router-dom";
import { Glyphicon, Row, Col, Grid, Image, Navbar, Nav, NavItem } from "react-bootstrap";
import './App.css';
import GoUp from './components/GoUp';

const STICKY_SCROLL_OFFSET = 170;

class App extends Component {
  componentDidMount() {
    this.navbar = document.getElementById("navbar");
    this.menuLinks = Array.from(document.querySelectorAll(".menu li a"));
    document.addEventListener("scroll", this.handleScroll);
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    document.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    this.navbar.classList.toggle("is-sticky", window.scrollY > STICKY_SCROLL_OFFSET);
    this.highlightActiveMenuLink();
  }

  highlightActiveMenuLink() {
    const fromTop = window.scrollY;
    this.menuLinks.forEach(link => {
      if (!link.hash) {
        return;
      }
      const section = document.querySelector(link.hash);
      if (!section) {
        return;
      }
      const isVisible = section.offsetTop <= fromTop && section.offsetTop + section.offsetHeight > fromTop;
      link.classList.toggle("active", isVisible);
    });
  }

  renderMenu() {
    return (
      <Navbar id="navbar">
        <Navbar.Toggle className="toggle" aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse>
          <Navbar.Toggle className="toggleNav" aria-controls="responsive-navbar-nav" />
          <Nav className="menu">
            <NavItem eventKey={1} href="#Header">Inicio</NavItem>
            <NavItem eventKey={2} href="#Quienes">Quiénes Somos</NavItem>
            <NavItem eventKey={3} href="#Productos">Productos</NavItem>
            <NavItem eventKey={4} href="#Contacto">Contacto</NavItem>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }

  renderHeader() {
    return (
      <div>
        <Navbar className="pre-head" id="Header">
          <Row>
            <Col md={4}>
              <span className="head-text-icon">
                <Glyphicon glyph="map-marker" />
                Bucarest 17 - Oficina 33 - Providencia
              </span>
              <span className="head-text-icon">
                <Glyphicon glyph="phone" />
                22697 4722
              </span>
            </Col>
          </Row>
        </Navbar>
        <Grid className="header">
          <Row>
            <Col xs={12}>
              <div className="mast-head-wrap">
                <div className="mast-head-left">
                  <h1 className="site-logo">
                    <Link to="/" className="custom-logo-link" rel="home">
                      <Image src="/images/logo.jpg" width="260" height="227" className="custom-logo" alt="Map Seguros" />
                    </Link>
                  </h1>
                </div>
                <div className="mast-head-right">
                  {this.renderMenu()}
                </div>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }

  renderFooter() {
    return (
      <div className="footer">
        <GoUp />
        <Navbar>
          <Row>
            <Col md={6} className="company">
              <Navbar.Text>
                <Navbar.Link href="https://www.mapseguros.cl/">Map Seguros</Navbar.Link> - Corredores de Seguros
              </Navbar.Text>
            </Col>
            <Col md={6} className="developer">
              <Navbar.Text>
                Sitio desarrollado por <Navbar.Link href="https://www.neokode.cl" target="_blank" rel="noopener noreferrer">Neokode</Navbar.Link>
              </Navbar.Text>
            </Col>
          </Row>
        </Navbar>
      </div>
    );
  }

  render() {
    return (
      <div className="App">
        <header>
          {this.renderHeader()}
        </header>
        <main>
          <Routes />
        </main>
        <footer>
          {this.renderFooter()}
        </footer>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js